import React, { useCallback } from 'react';
import { Box, Fab, Zoom, useScrollTrigger } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export type BackToTopButtonProps = {
  /**
   * CSS selector for the element you want to scroll to.
   * If not found, falls back to window top.
   */
  targetSelector?: string;
  /** Show after this many px of scroll */
  threshold?: number;
  /** Fixed positioning offsets */
  bottom?: number;
  right?: number;
};

const BackToTopButton: React.FunctionComponent<BackToTopButtonProps> = ({
  targetSelector = '#top',
  threshold = 200,
  bottom = 24,
  right = 24,
}) => {
  const show = useScrollTrigger({
    disableHysteresis: true,
    threshold,
  });

  const handleClick = useCallback(() => {
    const target = document.querySelector(targetSelector);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [targetSelector]);

  return (
    <Zoom in={show}>
      <Box
        role="presentation"
        sx={{
          position: 'fixed',
          bottom,
          right,
          zIndex: (theme) => theme.zIndex.tooltip,
        }}
      >
        <Fab size="large" color="primary" aria-label="back to top" onClick={handleClick}>
          <KeyboardArrowUpIcon />
        </Fab>
      </Box>
    </Zoom>
  );
};

export default BackToTopButton;
